export type BranchHealthStatus = 'green' | 'yellow' | 'red';

export type BranchHealth = {
  status: BranchHealthStatus;
  message: string;
  shortLabel: string;
  color: string;
};

/**
 * Indicador de salud de la sucursal según sync, inventario y ventas.
 * Verde: todo ok; Amarillo: advertencias; Rojo: crítico (fallidos, stock negativo, etc).
 */
export function getBranchHealth(params: {
  syncFailed: number;
  syncPending: number;
  stockNegative?: number;
  stockExpiringSoon?: number;
  stockBelowMin?: number;
  pendingPayments?: number;
}): BranchHealth {
  const {
    syncFailed,
    syncPending,
    stockNegative = 0,
    stockExpiringSoon = 0,
    stockBelowMin = 0,
    pendingPayments = 0,
  } = params;

  if (syncFailed > 0 || stockNegative > 0) {
    const parts: string[] = [];
    if (syncFailed > 0) parts.push(`${syncFailed} sincronizaciones fallidas`);
    if (stockNegative > 0) parts.push('Stock negativo');
    return {
      status: 'red',
      message: parts.join(' · '),
      shortLabel: 'Crítico',
      color: '#F87171',
    };
  }

  const warnings: string[] = [];
  if (syncPending > 5) warnings.push(`${syncPending} pendientes de sincronización`);
  if (stockBelowMin > 0) warnings.push(`${stockBelowMin} productos bajo mínimo`);
  if (stockExpiringSoon > 0) warnings.push(`${stockExpiringSoon} productos por vencer`);
  if (pendingPayments > 0) warnings.push(`${pendingPayments} cobros pendientes`);

  if (warnings.length > 0) {
    return {
      status: 'yellow',
      message: warnings.join(' · '),
      shortLabel: 'Atención',
      color: '#FACC15',
    };
  }

  return {
    status: 'green',
    message: 'Todo en orden',
    shortLabel: 'En orden',
    color: '#4ADE80',
  };
}
